import removeAttributesFromStore from "../../../../helpers/Attribute/removeAttributesFromStore";

const deleteAttributesResponder = ({ queryClient }) => {
  return {
    onSuccess: (returnedData, variables) => {
      removeAttributesFromStore({
        queryClient,
        removedItems: variables.args.deletedItemsIds,
      });
    },
    onError: (err) => {
      console.error("Error deleting Attributes", err);
    },
  };
};

export default deleteAttributesResponder;
